import { combineReducers } from '@reduxjs/toolkit';

import { onboardingDataReducer as onboardingData } from '../../onboarding/onboarding-data';
import ajaxCallsInProgress from './ajax-status-reducer';
import bankData from './bank-data-reducer';
import campaignsData from './campaign-reducer';
import competitions from './competitions-reducer';
import { domainInfoReducer } from './domain-info-reducer';
import { feedReducer } from './feed-reducer';
import instanceInfo from './instance-info-reducer';
import offersAndGames from './offers-and-games-reducer';
import { panelInfoLoadedReducer as panelInfoLoaded, panelInfoReducer as panelInfo } from './panel-info-reducer';
import redemptionResult from './redeem-reducer';
import redemptionAvailability from './redemption-availability-reducer';
import redemptions from './redemption-reducer';
import redemptionTrans from './redemption-trans-reducer';
import routeType from './route-type-reducer';
import {
  surveyThemeLoadedReducer as surveyThemeLoaded,
  surveyThemeReducer as surveyTheme,
} from './survey-theme-reducer';
import surveyThemes from './survey-themes-reducer';
import transactionsFiltering from './transaction-filtering-reducer';
import transactionsInfo from './transaction-reducer';
import transactionsMonth from './transactions-month-reducer';
import userBalance from './user-balance-reducer';
import userProfile from './user-profile-reducer';

const rootReducer = combineReducers({
  ajaxCallsInProgress,
  bankData,
  campaignsData,
  competitions,
  domainInfo: domainInfoReducer,
  feed: feedReducer,
  instanceInfo,
  offersAndGames,
  onboardingData,
  panelInfo,
  panelInfoLoaded,
  redemptionAvailability,
  redemptionResult,
  redemptions,
  redemptionTrans,
  routeType,
  surveyTheme,
  surveyThemeLoaded,
  surveyThemes,
  transactionsFiltering,
  transactionsInfo,
  transactionsMonth,
  userBalance,
  userProfile,
});

export default rootReducer;
